module.exports = __webpack_public_path__ + "5e6473f9a9e2eb218dedbd44487e01b8.svg";